import type { ProjectsBatchEditProps } from "./projects-batch-edit.type";

import BatchEditSelect from "@/modules/batch-edit-select";

import { ProjectsBatchEditContent } from "./projects-batch-edit-content";
import { useProjectsBatchEditProperties } from "./projects-batch-edit.hook";

export const ProjectsBatchEdit = ({ projects }: ProjectsBatchEditProps) => {
  const { properties, currentProperty, setCurrentProperty } =
    useProjectsBatchEditProperties();

  return (
    <div className="projects-batch-edit">
      <BatchEditSelect
        type="project"
        items={projects}
        properties={properties}
        onPropertyChange={setCurrentProperty}
      />
      <ProjectsBatchEditContent
        property={currentProperty}
        projects={projects}
      />
    </div>
  );
};
